import { useState } from "react";
import AppLayout from "@/components/AppLayout";
import { CalendarView } from "@/components/calendar/CalendarView";
import { WeatherWidget } from "@/components/calendar/WeatherWidget";
import { EventDialog } from "@/components/calendar/EventDialog";
import { CalendarFilters } from "@/components/calendar/CalendarFilters";
import { GoogleCalendarSync } from "@/components/calendar/GoogleCalendarSync";
import { Button } from "@/components/ui/button";
import { Plus, Cloud } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

export default function Calendar() {
  const { user } = useAuth();
  const [view, setView] = useState<'month' | 'week' | 'day' | 'agenda'>('month');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isEventDialogOpen, setIsEventDialogOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [filters, setFilters] = useState({
    eventType: 'all',
    showWeather: true
  });

  return (
    <AppLayout>
      <div className="flex flex-col h-screen">
        {/* Header - Mobile responsive */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 px-4 sm:px-6 py-3 sm:py-4 border-b border-border bg-background">
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
            <h1 className="text-xl sm:text-2xl font-bold text-foreground">Schedule Calendar</h1>
            <CalendarFilters 
              view={view}
              onViewChange={setView}
              filters={filters}
              onFiltersChange={setFilters}
            />
          </div>
          <div className="flex gap-2 w-full sm:w-auto">
            <GoogleCalendarSync />
            <Button 
              onClick={() => setIsEventDialogOpen(true)}
              className="flex-1 sm:flex-none h-11 sm:h-10"
            >
              <Plus className="h-4 w-4 sm:mr-2" />
              <span className="sm:inline">New Event</span>
            </Button>
          </div>
        </div>

        {/* Full Screen Calendar */}
        <div className="flex-1 flex overflow-hidden">
          <CalendarView
            view={view}
            selectedDate={selectedDate}
            onDateSelect={setSelectedDate}
            onEventClick={(event) => {
              setSelectedEvent(event);
              setIsEventDialogOpen(true);
            }}
            filters={filters}
          />
        </div>

        {/* Event Dialog */}
        <EventDialog
          open={isEventDialogOpen}
          onOpenChange={(open) => {
            setIsEventDialogOpen(open);
            if (!open) setSelectedEvent(null);
          }}
          event={selectedEvent}
          defaultDate={selectedDate}
        />
      </div>
    </AppLayout>
  );
}